import { SHARED_REACT_QUERY_CONFIG } from '../../constants/reactQuery.constant';
import { incidents } from '../../services/incidents/incidents.service';
import { incident } from '../../services/incidents/incidents.service';

export const INCIDENTS_QUERY = 'incidents';
export const INCIDENTS_QUERY_CONFIG = SHARED_REACT_QUERY_CONFIG;

export const incidentsQuery = async () => {
  const request = await incidents();
  return request.data;
};

export const incidentQuery = async ({ queryKey }: any) => {
  const params = queryKey[1];
  const request = await incident(params.id);
  return request.data;
};
